<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 设置中心 </el-breadcrumb-item>
                <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
                <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
                <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
            </el-tabs>

            <CardBox mTitle="主题色设置">
                <!-- <template v-slot:titleRight>右侧标题</template> -->
                <template v-slot:content>
                    <el-form ref="mapForm" class="mapElFrom" :model="mapForm" label-width="100px">
                        <el-form-item label="地图中心点">
                            <el-color-picker v-model="color1"></el-color-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">保存设置</el-button>
                            <el-button>取消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </CardBox>
        </div>
    </div>
</template>

<script>
import CardBox from '../common/cardBox';
export default {
    data() {
        return {
            activeName: 'first',

            color1: '#409EFF',
            mapForm: {
                centerLocation: '',
                zIndex: ''
            }
        };
    },
    components: {
        CardBox
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        }
    }
};
</script>

<style lang="less" scoped>
</style>